import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Loader } from '@progress/kendo-react-indicators';
import React from 'react';
import { useAppDispatch } from '../../app/hooks/store-hooks';
import { deleteDrawingObject } from '../../app/state/slices/drawing-objects-slice';
import { drawingObjectSetIdleWorkspace } from '../../app/state/slices/workspace-slice';
import { TrashOutline } from '../../icons/icons';
import { DrawingObject } from './types';

export function DrawingObjectDelete(props: { object: DrawingObject }) {
    const [busy, setBusy] = React.useState(false);
    const dispatch = useAppDispatch();

    const handleConfirmDelete = async () => {
        try {
            setBusy(true);

            const result = await dispatch(deleteDrawingObject(props.object.id)).unwrap();
            if (!result.success) {
                return;
            }
            dispatch(drawingObjectSetIdleWorkspace());
        } finally {
            setBusy(false);
        }
    };

    return (
        <Dialog title={'Delete drawing object'} closeIcon={false}>
            <div>
                <div>Do you want to delete the object:</div>
                <strong>{props.object.name}</strong>
            </div>
            {busy && (
                <div
                    style={{ position: 'absolute', background: 'rgba(0,0,0,0.20)', top: 0, bottom: 0, left: 0, right: 0 }}
                    className="d-flex align-items-center justify-content-center">
                    <Loader type={'infinite-spinner'} />
                </div>
            )}
            <DialogActionsBar>
                <div className="d-flex gap-2">
                    <Button
                        className="flex-grow-1 w-50"
                        themeColor={'error'}
                        fillMode={'outline'}
                        svgIcon={TrashOutline}
                        onClick={handleConfirmDelete}
                        disabled={busy}>
                        Delete
                    </Button>
                    <Button
                        className="flex-grow-1 w-50"
                        fillMode={'outline'}
                        onClick={() => dispatch(drawingObjectSetIdleWorkspace())}
                        disabled={busy}>
                        Cancel
                    </Button>
                </div>
            </DialogActionsBar>
        </Dialog>
    );
}
